/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_DurationInputs */

const en_admin_external_booking_edit_duration = /** @type {(inputs: Admin_External_Booking_Edit_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration`)
};

const de_admin_external_booking_edit_duration = /** @type {(inputs: Admin_External_Booking_Edit_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer`)
};

const es_admin_external_booking_edit_duration = /** @type {(inputs: Admin_External_Booking_Edit_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración`)
};

const fr_admin_external_booking_edit_duration = /** @type {(inputs: Admin_External_Booking_Edit_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée`)
};

const nl_admin_external_booking_edit_duration = /** @type {(inputs: Admin_External_Booking_Edit_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duur`)
};

/** @type {(inputs: Admin_External_Booking_Edit_DurationInputs) => LocalizedString} */
const it_admin_external_booking_edit_duration = en_admin_external_booking_edit_duration;

/** @type {(inputs: Admin_External_Booking_Edit_DurationInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_duration = en_admin_external_booking_edit_duration;

/** @type {(inputs: Admin_External_Booking_Edit_DurationInputs) => LocalizedString} */
const pl_admin_external_booking_edit_duration = en_admin_external_booking_edit_duration;

/** @type {(inputs: Admin_External_Booking_Edit_DurationInputs) => LocalizedString} */
const hu_admin_external_booking_edit_duration = en_admin_external_booking_edit_duration;

/** @type {(inputs: Admin_External_Booking_Edit_DurationInputs) => LocalizedString} */
const ro_admin_external_booking_edit_duration = en_admin_external_booking_edit_duration;

/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Admin_External_Booking_Edit_DurationInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_duration = /** @type {((inputs?: Admin_External_Booking_Edit_DurationInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_DurationInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_duration(inputs)
	if (locale === "de") return de_admin_external_booking_edit_duration(inputs)
	if (locale === "es") return es_admin_external_booking_edit_duration(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_duration(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_duration(inputs)
	if (locale === "it") return it_admin_external_booking_edit_duration(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_duration(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_duration(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_duration(inputs)
	return ro_admin_external_booking_edit_duration(inputs)
});
export { admin_external_booking_edit_duration as "admin.external_booking_edit.duration" }